export default __webpack_public_path__ + "static/media/children.8af56845.jpeg";